import React from 'react'

import { slugToTopic } from '../../components/utils'
import { PageConfig } from '../../routing/types'
import { buildPath } from '../../routing/utils'

import PostArticle from './components/PostArticle'
import PostVideo from './components/PostVideo'
import { Props } from './data'
import ROUTE from './route'

const Post: PageConfig<Props> = (post) => {
  const topics =
    post.topics?.nodes.map((topic) => ({
      topic: slugToTopic(topic.slug),
      href: buildPath('topics-view', { params: { topicSlug: topic.slug } }),
    })) || []
  const series = {
    ...post.collections?.nodes[0],
    posts: post.collections?.nodes[0]?.posts?.nodes ?? [],
  }
  const guide = post.guides?.nodes[0]
    ? {
        title: post.guides?.nodes[0].title,
        slug: post.guides?.nodes[0].slug,
        posts: post.guides.nodes[0].posts,
      }
    : undefined

  switch (post.__typename) {
    case 'LibraryPostArticle': {
      return (
        <PostArticle
          slug={post.slug}
          key={post.id}
          title={post.title}
          guide={guide}
          heroImage={post.imageCropped}
          image={post.image}
          description={post.description}
          body={post.body}
          intro={post.intro}
          illustratorName={post.illustratorName || undefined}
          illustratorUrl={post.illustratorUrl || undefined}
          authorName={post.author.name}
          authorUrl={post.author.url ?? undefined}
          authorBio={post.author.description || undefined}
          publishedAt={post.publishedAt}
          topics={topics}
          series={series as any}
          relatedPosts={post.relatedPosts?.nodes || []}
        />
      )
    }
    case 'LibraryPostVideo': {
      return (
        <PostVideo
          slug={post.slug}
          key={post.id}
          title={post.title}
          guide={guide}
          description={post.description}
          image={post.image}
          intro={post.intro}
          wistiaId={post.wistiaId}
          difficultyLevel={post.difficultyLevel}
          authorName={post.author.name}
          authorUrl={post.author.url ?? undefined}
          publishedAt={post.publishedAt}
          topics={topics}
          series={series as any}
          transcript={post.transcripts || []}
          relatedPosts={post.relatedPosts?.nodes || []}
          demoUrl={post.demoUrl || undefined}
          next={post.next || undefined}
          previous={post.previous || undefined}
        />
      )
    }
  }
}

Post.route = ROUTE

export { getStaticPaths, getStaticProps } from './data'
export default Post
